import React, { useMemo } from "react";
import { sanitizeRichHtml } from "../../utils/RichHtmlSanitizer";

interface IRichHtmlContentProps {
  html: string | null;
}

const ICRichHtmlContent: React.FC<IRichHtmlContentProps> = ({ html }) => {
  const sanitizedHtml = useMemo(() => sanitizeRichHtml(html).html, [html]);

  if (!sanitizedHtml) return null;

  return (
    <div
      className="rich-html-content"
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};

export default ICRichHtmlContent;
